import React from "react";
import styles from "./Loader.module.css";

const SkeletonLoader = () => {
  return (
    <div className={styles.body}>
      <div className={styles.body_header}>
        {[1, 2, 3].map((stat) => (
          <div
            key={stat}
            className={`${styles.customer_stat} skeleton-pulse`}
            style={{
              background: "white",
              border: "1px solid #E0E0E0",
            }}
          >
            <div
              style={{
                width: "60%",
                height: "15px",
                background: "#E0E0E0",
                marginBottom: "10px",
              }}
            ></div>
            <div
              style={{
                width: "40%",
                height: "15px",
                background: "#E0E0E0",
              }}
            ></div>
          </div>
        ))}
      </div>

      {/* Skeleton Filter Wrapper */}
      <div
        className={styles.filter_wrapper}
        style={{
          background: "white",
          border: "1px solid #E0E0E0",
        }}
      >
        {[1, 2].map((input) => (
          <div
            key={input}
            style={{
              width: "143px",
              height: "36px",
              background: "#E0E0E0",
            }}
          ></div>
        ))}
        <div
          style={{
            width: "34px",
            height: "28px",
            background: "#E0E0E0",
          }}
        ></div>
      </div>

      {/* Skeleton Table Header */}
      <div
        className={styles.table_header}
        style={{
          background: "white",
          border: "1px solid #E0E0E0",
        }}
      >
        {[1, 2, 3, 4, 5].map((col) => (
          <div
            key={col}
            className={styles.table_column}
            style={{
              background: "#F0F0F0",
              height: "45px",
            }}
          >
            <div
              style={{
                width: "80%",
                height: "15px",
                background: "#E0E0E0",
              }}
            ></div>
          </div>
        ))}
      </div>

      {/* Skeleton Table Inner */}
      <div
        className={styles.table_inner}
        style={{
          background: "white",
          border: "1px solid #E0E0E0",
        }}
      >
        {[1, 2, 3, 4, 5].map((row) => (
          <div
            key={row}
            className={styles.table_header_wrapper}
            style={{
              background: "white",
              border: "1px solid #F0F0F0",
            }}
          >
            <div className={styles.table_header}>
              {[1, 2, 3, 4, 5].map((col) => (
                <div
                  key={col}
                  className={styles.table_column}
                  style={{
                    background: "#F5F5F5",
                    height: "45px",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      height: "12px",
                      background: "#E0E0E0",
                    }}
                  ></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonLoader;
